<template>
  <div>
    <div class="bottom-text">X-Brick Tool | XKool.ai</div>
    <div class="bottom-text">
      Designed and Developed by ART | XKool © 2022 XKool, All rights reserved
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomContent"
};
</script>

<style scoped lang="less">
.bottom-text {
  width: 100%;
  font-size: 70%;
  text-align: center;
  color: #6e6e6e;
}
</style>
